// extracted by mini-css-extract-plugin
module.exports = {"circle":"styles_circle__3FGZA","round":"styles_round__3jOU_"};